// This file was automatically generated from badPasswordAutodetect.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.badPasswordAutodetect');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.badPasswordAutodetect.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><a class="el8Btn el8BtnXs el8BtnDefault el8BtnPrimary el8BackLink" href="', soy.$$escapeHtml(opt_data.backUrl), '">&#x2190; Try again</a><h3 class="el8BrandColor el8LightWeight el8AlignCenter">Having trouble with your password?</h3><div class="el8MdSpacer"></div>');
  if (opt_data.hasSecurityQA) {
    el8.template.multiuser_access.badPasswordAutodetect.withSecurityQAAction(opt_data, output);
  } else {
    el8.template.multiuser_access.badPasswordAutodetect.noSecurityQAAction(opt_data, output);
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.badPasswordAutodetect.withSecurityQAAction = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="w80p el8CenterBlock"><h4 class="el8AlignCenter mbMd">You may reset your password by answering your security question.</h4><div class="el8MdSpacer"></div><div class="el8AlignCenter"><a href="', soy.$$escapeHtml(opt_data.passwordHelpTriageUrl), '" class="el8Btn el8BtnPrimary">Show me the security question</a></div></div><div class="el8MdSpacer"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.badPasswordAutodetect.noSecurityQAAction = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="w80p el8CenterBlock"><h4 class="el8AlignCenter mbMd">Since you have already entered the reference code, you may view the documents in the patient chart as PDFs only.</h4><div class="el8MdSpacer"></div><div class="el8AlignCenter"><a href="', soy.$$escapeHtml(opt_data.viewDocumentUrl), '" class="el8Btn el8BtnPrimary">View Documents</a></div></div><div class="el8MdSpacer"></div>', (opt_data.hasVerifiedEmail) ? '<p class="mtMd el8AlignCenter"><a href="' + soy.$$escapeHtml(opt_data.passwordHelpTriageUrl) + '">I forgot my password.</a></p><div class="el8MdSpacer"></div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
